export const Data = [
  {
    name: "C++",
    url: "https://img.icons8.com/color/192/000000/c-plus-plus-logo.png",
  },
  // {
  //     "name": "Java",
  //     "url": "https://img.icons8.com/color/192/000000/java-coffee-cup-logo.png"
  // },
  {
    name: "Python",
    url: "https://img.icons8.com/color/192/000000/python.png",
  },
  // {
  //     "name": "Dart",
  //     "url": "https://img.icons8.com/color/192/000000/dart.png"
  // },
  // {
  //     "name": "Kotlin",
  //     "url": "https://img.icons8.com/color/192/000000/kotlin.png"
  // },
  {
    name: "HTML",
    url: "https://img.icons8.com/color/192/000000/html-5.png",
  },
  {
    name: "CSS",
    url: "https://img.icons8.com/color/192/000000/css3.png",
  },
  {
    name: "JavaScript",
    url: "https://img.icons8.com/color/192/000000/javascript.png",
  },
  {
    name: "MySQL",
    url: "https://img.icons8.com/fluency/192/000000/mysql-logo.png",
  },
  {
    name: "MongoDB",
    url: "https://img.icons8.com/color/192/000000/mongodb.png",
  },
  {
    name: "Firebase",
    url: "https://img.icons8.com/color/192/000000/firebase.png",
  },
  // {
  //     "name": "Redis",
  //     "url": "https://img.icons8.com/color/480/000000/redis.png"
  // },
  // {
  //     "name": "Flutter",
  //     "url": "https://img.icons8.com/color/192/000000/flutter.png"
  // },
  // {
  //     "name": "React Native",
  //     "url": "https://img.icons8.com/color/192/000000/react-native.png"
  // },
  // {
  //     "name": "Android",
  //     "url": "https://img.icons8.com/color/192/000000/android-studio--v3.png"
  // },
  {
    name: "Node JS",
    url: "https://img.icons8.com/color/64/nodejs.png",
  },
  {
    name: "Express JS",
    url: "https://img.icons8.com/fluency/48/ffffff/express-js.png",
  },
  // {
  //     "name": "Socket.io",
  //     "url": "https://socket.io/images/logo.svg"
  // },
  {
    name: "React JS",
    url: "https://img.icons8.com/color/192/000000/react-native.png",
  },
  // {
  //     "name": "Next JS",
  //     "url": "https://www.svgrepo.com/show/354112/nextjs.svg"
  // },
  {
    name: "Tailwind",
    url: "https://img.icons8.com/color/64/tailwindcss.png",
  },
  // {
  //     "name": "Docker",
  //     "url": "https://img.icons8.com/fluency/100/000000/docker.png"
  // },
  // {
  //     "name": "GitHub Actions",
  //     "url": "https://avatars.githubusercontent.com/u/44036562?s=200&v=4"
  // },
  // {
  //     "name": "Heroku",
  //     "url": "https://img.icons8.com/color/480/000000/heroku.png"
  // },
  // {
  //     "name": "Netlify",
  //     "url": "https://img.icons8.com/external-tal-revivo-color-tal-revivo/384/000000/external-netlify-a-cloud-computing-company-that-offers-hosting-and-serverless-backend-services-for-static-websites-logo-color-tal-revivo.png"
  // },
  {
    name: "Photoshop",
    url: "https://img.icons8.com/color/192/000000/adobe-photoshop.png",
  },
  {
    name: "Illustrator",
    url: "https://img.icons8.com/color/192/000000/adobe-illustrator.png",
  },
  // {
  //     "name": "Premiere Pro",
  //     "url": "https://img.icons8.com/color/192/000000/adobe-premiere-pro.png"
  // },
  // {
  //     "name": "Adobe XD",
  //     "url": "https://img.icons8.com/color/192/000000/adobe-xd.png"
  // },
  {
    name: "Figma",
    url: "https://img.icons8.com/color/192/000000/figma.png",
  },
  // {
  //     "name": "Git",
  //     "url": "https://img.icons8.com/color/192/000000/git.png"
  // }
];